module.exports = __webpack_public_path__ + "img/landscapex.d2136b5.png";